import script from "./news.vue?vue&type=script&setup=true&lang=js"
export * from "./news.vue?vue&type=script&setup=true&lang=js"

import "./news.vue?vue&type=style&index=0&id=77f0ec52&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f0ec52"]])

export default __exports__